"use client"
/* */
const locales = {"de-DE": {  "fileCard.delete": `Entfernen`,
},"en-US": {  "fileCard.delete": `delete`,
}};

export { locales as default };
//# sourceMappingURL=_.locale.json@c33938a00f4bfb40e033ada6b54e38f9.mjs.map
